export default (state, params) => {
  localStorage.set('token', params.publicToken)
  localStorage.set('shappyCustomToken', params.shappyCustomToken)
  localStorage.set('appId', params.appId)
  localStorage.set('channelId', params.channelId)
  localStorage.set('primaryColor', params.primaryColor)
  localStorage.set('secondaryColor', params.secondaryColor)
  localStorage.set('member', params.getUserInfo.member)
  localStorage.set('language', params.language)
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/mutations/setShappyParams.js